<template>
    <div class="wrapper">
        <h2>Api documentation</h2>
        <div class="row">
            <div class="doc-link">
                <a href="https://api.parley.nu/clientApi/latest/doc/" target="_blank">
                    <div class="api">
                        <i class="material-icons">perm_identity</i>
                        <h4>
                            Client API
                        </h4>
                    </div>
                </a>
            </div>

            <div class="doc-link">
                <a href="https://api.parley.nu/serviceApi/latest/doc/" target="_blank">
                    <div class="api">
                        <i class="material-icons">cloud_circle</i>
                        <h4>
                            Service API
                        </h4>
                    </div>
                </a>
            </div>

            <div class="doc-link">
                <a href="https://api.parley.nu/adminApi/latest/doc/" target="_blank">
                    <div class="api">
                        <i class="material-icons">visibility</i>
                        <h4>
                            Admin API
                        </h4>
                    </div>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import { Default } from '@/mixins/mixins';

export default {
    name: 'settingsApiDocs',
    mixins: [
        Default
    ],
    data() {
        return {};
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    a {
        color: $tertiary-color;

        &:hover {
            color: $primary-color;
        }
    }

    .api {
        margin: 1em 3em 1em 0;
        text-align: center;
        border: 1px solid #E8EBF0;
        border-radius: .5em;
        padding: 2em;

        .material-icons {
            font-size: 5em;
        }

        h4 {
            padding: 0;
            color: #A1A5B5;
        }
    }
</style>
